import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import { categories } from '@/mocks/site';
import { articles } from '@/mocks/articles';

const iconMap: Record<string, string> = {
  ent: 'ri-movie-2-line',
  biz: 'ri-store-3-line',
  tech: 'ri-cpu-line',
  fin: 'ri-line-chart-line',
  soc: 'ri-community-line',
  opi: 'ri-chat-smile-2-line',
};

export default function CategoryStrip() {
  return (
    <section id="categories" className="px-4 md:px-6 py-12 md:py-16">
      <SectionTitle
        eyebrow="主题分类"
        title="按方向找线报"
        desc="六个长期追踪的方向，每个方向都保留完整的事件归档与后续更新。"
      />
      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {categories.map((cat) => {
          const count = articles.filter((a) => a.categoryId === cat.id).length;
          return (
            <Link
              key={cat.id}
              to={`/feed?cat=${cat.id}`}
              className="group rounded-lg border border-background-200/80 bg-background-50 p-5 hover:border-primary-300 hover:bg-primary-50/60 transition-colors"
            >
              <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center group-hover:bg-primary-100 group-hover:text-primary-700 transition-colors">
                <i className={`${iconMap[cat.id]} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{cat.name}</h3>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">{cat.desc}</p>
              <span className="mt-3 inline-block text-xs text-foreground-500">
                {count} 篇归档
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}